import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f65c1176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Ttn px-10 py-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Акт", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "Фото товара", -1))
const _hoisted_4 = {
  key: 2,
  class: "Ttn__box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении детальной информации произошла ошибка", -1))
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "Ttn__title" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.35294 2H11.6471C12.4268 2 13.0588 2.63207 13.0588 3.41176V4.35294C13.0588 5.13264 12.4268 5.76471 11.6471 5.76471H8.35294C7.57325 5.76471 6.94118 5.13264 6.94118 4.35294V3.41176C6.94118 2.63207 7.57325 2 8.35294 2ZM8.35294 2.94118C8.09304 2.94118 7.88235 3.15187 7.88235 3.41176V4.35294C7.88235 4.61284 8.09304 4.82353 8.35294 4.82353H11.6471C11.907 4.82353 12.1176 4.61284 12.1176 4.35294V3.41176C12.1176 3.15187 11.907 2.94118 11.6471 2.94118H8.35294ZM8.35294 14.2353H11.6471C12.4268 14.2353 13.0588 14.8674 13.0588 15.6471V16.5882C13.0588 17.3679 12.4268 18 11.6471 18H8.35294C7.57325 18 6.94118 17.3679 6.94118 16.5882V15.6471C6.94118 14.8674 7.57325 14.2353 8.35294 14.2353ZM8.35294 15.1765C8.09304 15.1765 7.88235 15.3872 7.88235 15.6471V16.5882C7.88235 16.8481 8.09304 17.0588 8.35294 17.0588H11.6471C11.907 17.0588 12.1176 16.8481 12.1176 16.5882V15.6471C12.1176 15.3872 11.907 15.1765 11.6471 15.1765H8.35294ZM8.35294 8.11765H11.6471C12.4268 8.11765 13.0588 8.74972 13.0588 9.52941V10.4706C13.0588 11.2503 12.4268 11.8824 11.6471 11.8824H8.35294C7.57325 11.8824 6.94118 11.2503 6.94118 10.4706V9.52941C6.94118 8.74972 7.57325 8.11765 8.35294 8.11765ZM8.35294 9.05882C8.09304 9.05882 7.88235 9.26951 7.88235 9.52941V10.4706C7.88235 10.7305 8.09304 10.9412 8.35294 10.9412H11.6471C11.907 10.9412 12.1176 10.7305 12.1176 10.4706V9.52941C12.1176 9.26951 11.907 9.05882 11.6471 9.05882H8.35294ZM4.58336 16.4601C3.08497 16.0448 2 14.6704 2 13.0588C2 11.1096 3.58017 9.52941 5.52941 9.52941H5.76471C6.0246 9.52941 6.23529 9.7401 6.23529 10C6.23529 10.2599 6.0246 10.4706 5.76471 10.4706H5.52941C4.09997 10.4706 2.94118 11.6294 2.94118 13.0588C2.94118 14.2584 3.76133 15.2791 4.88518 15.5664L4.6553 15.1833C4.52158 14.9604 4.59385 14.6714 4.81671 14.5377C5.03957 14.4039 5.32863 14.4762 5.46235 14.6991L6.16823 15.8755C6.28942 16.0775 6.24261 16.338 6.05868 16.4851L4.88221 17.4263C4.67926 17.5887 4.38313 17.5557 4.22077 17.3528C4.05841 17.1499 4.09131 16.8537 4.29426 16.6913L4.58336 16.4601ZM15.4166 10.3424L15.7057 10.5737C15.9087 10.7361 15.9416 11.0322 15.7792 11.2352C15.6169 11.4381 15.3207 11.471 15.1178 11.3087L13.9413 10.3675C13.7574 10.2203 13.7106 9.95988 13.8318 9.7579L14.5377 8.58143C14.6714 8.35857 14.9604 8.28629 15.1833 8.42001C15.4062 8.55373 15.4784 8.84277 15.3447 9.06563L15.1148 9.44879C16.2391 9.16138 17.0588 8.14033 17.0588 6.94118C17.0588 5.51173 15.9 4.35294 14.4706 4.35294H14.2353C13.9754 4.35294 13.7647 4.14225 13.7647 3.88235C13.7647 3.62245 13.9754 3.41176 14.2353 3.41176H14.4706C16.4198 3.41176 18 4.99194 18 6.94118C18 8.55216 16.9156 9.92701 15.4166 10.3424Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Транзитный груз ")
], -1))
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = {
  key: 0,
  class: "TtnTabs"
}
const _hoisted_13 = { class: "TtnTabs__container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "Ttn__content"
}
const _hoisted_16 = {
  key: 0,
  class: "Ttn__grid"
}
const _hoisted_17 = { class: "Ttn__small-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Ttn__subtitle" }, "ОСНОВНАЯ ИНФОРМАЦИЯ", -1))
const _hoisted_19 = { class: "SmallGrid" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Филиал", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Маршрут", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Перевозчик", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Водитель", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Контакты", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Авто", -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Рейс", -1))
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "Ttn__small-box" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Ttn__subtitle" }, "ДАТА", -1))
const _hoisted_32 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_33 = { class: "SmallTitle" }
const _hoisted_34 = { class: "Ttn__small-box" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Ttn__subtitle" }, [
  /*#__PURE__*/_createTextVNode(" ОПЛАТА "),
  /*#__PURE__*/_createElementVNode("p", { class: "Ttn__micro-title" }, "Сумма указана без НДС")
], -1))
const _hoisted_36 = { class: "SmallGrid" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "ТГ/кг", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Стоимость", -1))
const _hoisted_39 = { class: "Ttn__small-box" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Ttn__subtitle" }, "АНАЛИТИКА", -1))
const _hoisted_41 = { class: "SmallGrid" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Фактический вес ТТН", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Объем", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Объемный вес", -1))
const _hoisted_45 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "Ttn__small-box" }
const _hoisted_48 = { class: "Ttn__small-box mt-5" }
const _hoisted_49 = {
  key: 2,
  class: "Ttn__box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ttn_edit_modal = _resolveComponent("ttn-edit-modal")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_ttn_timer = _resolveComponent("ttn-timer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TtnInvoices = _resolveComponent("TtnInvoices")!
  const _component_ttn_files = _resolveComponent("ttn-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.edit_state.is_open)
      ? (_openBlock(), _createBlock(_component_ttn_edit_modal, {
          key: 0,
          item: _ctx.state.ttn,
          onClose: _ctx.closeEdit
        }, null, 8, ["item", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_files)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 1,
          title: "Акт об обнаружении недостатков",
          loading: _ctx.state.is_files_loading,
          onSubmit: _ctx.loadFiles,
          onCancel: _ctx.toggleFiles
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_file_reader, {
              class: "mt-1",
              placeholder: "Фото акта",
              value: _ctx.state.actFiles,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.actFiles) = $event)),
              "is-invalid": _ctx.validation$.actFiles.$error,
              "validation-errors": _ctx.validation$.actFiles.$errors,
              multiple: ""
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _hoisted_3,
            _createVNode(_component_file_reader, {
              class: "mt-1",
              placeholder: "Фото товара",
              value: _ctx.state.productFiles,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.productFiles) = $event)),
              multiple: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.ttn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createVNode(_component_new_button, {
                    class: "mt-3",
                    onClick: _ctx.loadTtn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.ttn)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" Нет данных ")
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_page_title, { title: _ctx.pageTitle }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.state.ttn.isTransit)
                  ? (_openBlock(), _createBlock(_component_cheap, {
                      key: 0,
                      class: "small orange--fill"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.ttn.status)
                  ? (_openBlock(), _createBlock(_component_cheap, {
                      key: 1,
                      class: _normalizeClass(_ctx.getCheapClass)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.ttn.status.name), 1)
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_new_button, {
                class: "NewButton--transparent TripsTable__btn",
                onClick: _ctx.openEdit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ttn_timer, {
                "status-id": _ctx.state.ttn.status.id,
                dates: _ctx.state.ttn.dates,
                "delayed-time": _ctx.state.ttn.delayedTime
              }, null, 8, ["status-id", "dates", "delayed-time"]),
              _createVNode(_component_new_button, {
                class: "ml-3",
                onClick: _ctx.toggleFiles
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Заполнить акт ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          (_ctx.isTabs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TABS, (tab) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tab.id,
                      class: _normalizeClass(["container__tab", { 'tab--active': _ctx.isTabSelected(tab) }]),
                      onClick: ($event: any) => (_ctx.selectTab(tab))
                    }, _toDisplayString(tab.name), 11, _hoisted_14))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.ttn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.isGeneral)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.warehouseName), 1),
                          _hoisted_21,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.fromCity ? _ctx.state.ttn.fromCity.name : '...') + " - " + _toDisplayString(_ctx.state.ttn.toCity ? _ctx.state.ttn.toCity.name : '...'), 1),
                          _hoisted_22,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.company ? _ctx.state.ttn.company.shortName : '-'), 1),
                          _hoisted_23,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.courier ? _ctx.state.ttn.courier.fullName : '-'), 1),
                          _hoisted_24,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.courier ? _ctx.state.ttn.courier.phoneNumber : '-'), 1),
                          _hoisted_25,
                          (_ctx.state.ttn.car)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.car.model), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.car.number), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_27, "-")),
                          _hoisted_28,
                          (_ctx.state.ttn.tripId)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                class: "text-blue-500",
                                to: `/tms/trips/${_ctx.state.ttn.tripId}`,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.state.ttn.tripNumber), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_29, "-"))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.ttn.dates, (date, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `date-${idx}`,
                              class: "SmallGrid gap-0"
                            }, [
                              _createElementVNode("p", _hoisted_33, _toDisplayString(date.dateRef.name) + ":", 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(date.date)), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.costPerWeight || '-'), 1),
                          _hoisted_38,
                          _createElementVNode("p", null, _toDisplayString(`${_ctx.state.ttn.costPerWeightPercent} %` || '-'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.totalWeight) + " кг (" + _toDisplayString(_ctx.state.ttn.carLoadedPercent) + "%) ", 1),
                          _hoisted_43,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.totalCubature) + " (" + _toDisplayString(_ctx.state.ttn.loadedVolumePercent) + "%) ", 1),
                          _hoisted_44,
                          _createElementVNode("p", null, _toDisplayString(_ctx.state.ttn.totalVolumeWeight), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isGeneral)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createVNode(_component_TtnInvoices, {
                        "ttn-id": _ctx.ttnId,
                        directions: _ctx.state.ttn.invoicesByDirection,
                        "directions-two": _ctx.state.ttnTwo.invoicesByDirection
                      }, null, 8, ["ttn-id", "directions", "directions-two"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isFiles)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_ttn_files, {
                          files: _ctx.state.ttn.defectActs,
                          title: "Акты"
                        }, null, 8, ["files"])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_ttn_files, {
                          files: _ctx.state.ttn.defectProducts,
                          title: "Фото товара"
                        }, null, 8, ["files"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_49, "Нет данных"))
        ]))
  ]))
}